import { AppBar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { StyleBreakpoints } from '../../../utils/constants';
import { isPaymentsCompany } from '../../../utils/helpers';
import { getMyConfig } from '../../../api/messagingConfig';
import { useLocation } from 'react-router-dom';
import DesktopNavBar from './DesktopNavBar';
import MobileNavBar from './MobileNavBar';

const userNameOrMock = user => {
  const { firstName, lastName } = user.profile;
  return `${firstName || ''}${firstName && lastName ? ' ' : ''}${lastName || ''}`;
};

const useStyles = makeStyles({
  grow: {
    flexGrow: 1,
    marginBottom: '20px'
  },
  AppBar: {
    backgroundColor: '#ffffff',
    boxShadow: 'unset',
    borderBottom: '1px solid rgb(236,236,236)'
  }
});

export function PrimarySearchAppBar({
  user,
  withFilters = false,
  setIsOpenFilters,
  sendInvitesToGuides = null
}) {
  const classes = useStyles();
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [hasMessagingAlert, setHasMessagingAlert] = useState(false);
  // Payments companies get an at-a-glance branded accent along the top edge of
  // the nav (card 105) so it's obvious which kind of account you're looking at.
  const userIsPaymentsCompany = isPaymentsCompany(user?.companyId, user);

  useEffect(() => {
    if (user && Object.keys(user).length > 0 && user.role === 'system_admin') {
      console.info('[TopNav] Fetching messaging config...');
      getMyConfig()
        .then(config => {
          console.info('[TopNav] Messaging config received:', config);
          if (config && config.hasMissingReviewLinks) {
            console.info('[TopNav] Setting hasMessagingAlert to true');
            setHasMessagingAlert(true);
          } else {
            console.info('[TopNav] Setting hasMessagingAlert to false');
            setHasMessagingAlert(false);
          }
        })
        .catch(err => {
          console.error('[TopNav] Failed to fetch messaging config:', err);
        });
    }
  }, [user, location.pathname]);

  useEffect(() => {
    window.addEventListener('resize', handleWindowWidthChanged);
    return () => window.removeEventListener('resize', handleWindowWidthChanged);
  }, []);

  const handleWindowWidthChanged = () => {
    setWindowWidth(window.innerWidth);
  };

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <div className={classes.grow}>
      <AppBar position="static" className={classes.AppBar}>
        {userIsPaymentsCompany && (
          <div
            aria-hidden
            style={{
              height: '3px',
              flexShrink: 0,
              background:
                'linear-gradient(90deg, #26BFD1 0%, #6997ff 50%, #FE424D 100%)'
            }}
          />
        )}
        {windowWidth > parseInt(StyleBreakpoints.sm) ? (
          <DesktopNavBar
            username={userNameOrMock(user)}
            user={user}
            handleProfileMenuOpen={handleProfileMenuOpen}
            hasMessagingAlert={hasMessagingAlert}
          />
        ) : (
          <MobileNavBar
            username={userNameOrMock(user)}
            withFilters={withFilters}
            user={user}
            setIsOpenFilters={setIsOpenFilters}
            sendInvitesToGuides={sendInvitesToGuides}
            hasMessagingAlert={hasMessagingAlert}
          />
        )}
      </AppBar>
    </div>
  );
}

function mapStateToProps(state) {
  return { user: state.user.user };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrimarySearchAppBar);
